import React, { Fragment, useEffect, useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import { deleteOpening, fetchOpenings, newOpening, updateOpening } from '../util/http-openings';
import { niceDate } from '../util/date';
import { accessHelper, accessHelperText, isEditPermitted } from '../util/checkAccess';
import "./Home.css"

import { useMsal, useAccount } from '@azure/msal-react';
import { msalConfig } from '../config/msalConfig';



function Openings (props){       
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState(null);    
    const [openings, setOpenings] = useState([]);    
    const [dataLoaded, setDataLoaded] = useState(false);
    const [token, setToken] = useState();    
    
    const [from, setFrom] = useState('');
    const [to, setTo] = useState('');

    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0]);

    async function getToken() {
      const accessTokenRequest = {
        scopes: ["openid"],
        account: accounts[0],
      };
      const response = await instance.acquireTokenSilent(accessTokenRequest);
      // console.log('response', response);
      return `Bearer ${await response.idToken}`;  
    }    

    const onGridReady = (params) => {
        setGridApi(params.api);
      };

    async function loadFromDb() {              
        let t = await getToken();
        setToken(t);
        let _openings = await fetchOpenings();        
        if(_openings.status != 200) {
            console.log('ERROR error fetching openings: ', _openings.status);
        } else {
            // console.log('fetched openings; sample: ', _openings.data[0]);
            let filterdOpenings = await 
              _openings.data
              .filter((x) => x.idHeuriger === props.id && x?.deleted != true)
              .sort(
                (objA, objB) => Number(objA.from) - Number(objB.from),
              );

            setOpenings(filterdOpenings);
            setDataLoaded(true);
        }        
    }

    const ts2Date = (params) => {
        return niceDate(new Date(params.value*1000), 2);
      };

      const renderNiceDate = (params) => {        
        return niceDate(new Date(params.value), 0)
      }

      const deleteOpeningHandler = async (opening) => {
        let t = await getToken();
        await deleteOpening(opening, t);  
        loadFromDb();
      }

      const buttonDeleteOpening = (params) => {
    
              if (params.data.id) {
                return (
                  <button disabled={!editPermission} type="button" className="btn btn-primary btn-sm" onClick={e => deleteOpeningHandler(params.data)}>Löschen {token}</button>
                );
              } else {
                return <Fragment>-</Fragment>
              } 
      };

const addOpening = async () => {  
  let newO = {
    idHeuriger: props.id,
    from: from,
    to: to
  }
  let t = await getToken();
  await newOpening(newO, t);
  setFrom('');
  setTo('')
  loadFromDb();
}

const onCellValueChanged = async (params) => {
  // console.log('onRowValueChanged', params);
  // console.log('onRowValueChanged', params.value);

  let updatedOpening = {
    id: params.data.id,
    idHeuriger: params.data.idHeuriger,
    from: params.data.from,
    to: params.data.to
  }
  // console.log('updatedOpening', updatedOpening);
  await updateOpening(updatedOpening);
  loadFromDb();
}


    const [columnDefs] = useState([
        { headerName: 'Id', flex: 1, cellRenderer: buttonDeleteOpening },
        { field: "id", headerName: 'Id', flex: 2 },
        { field: "from", headerName: 'Von', flex: 2, valueFormatter: renderNiceDate, editable: true },
        { field: "to", headerName: 'Bis', flex: 2, valueFormatter: renderNiceDate, editable: true },        
        { field: "_ts", headerName: 'Letzte Änderung', flex: 1, valueFormatter: ts2Date}
    ]);
    
    const editPermission = isEditPermitted(props.currentAccount, props.id);

    useEffect(() => {        
        
        loadFromDb();

        if(gridApi && !dataLoaded) {
            gridApi.showLoadingOverlay();
          }
          if(gridApi && dataLoaded && openings?.length > 0) {
            gridApi.hideOverlay();
          }
    }, [props.id]); 

    return (                
            <div className="ag-theme-alpine" >                
                <AgGridReact
                    ref={gridRef}
                    defaultColDef={{sortable: true, filter: true, resizable: true }}
                    rowData={openings}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onCellValueChanged={onCellValueChanged}                    
                    localeText={{noRowsToShow: '...', loadingOoo: 'Daten werden geladen ...'}}            
                    domLayout='autoHeight'>
                </AgGridReact>
                <p></p>
                
                <div className="mb-3 ">
                  <label className="form-label">Von</label>
                  <input disabled={!editPermission} type="date" className="form-control" id="fromInput" placeholder="jjjj-m-t" value={from} onChange={e => setFrom(e.target.value)}/>
                </div>                
                <div className="mb-3">
                  <label className="form-label">Bis</label>
                  <input disabled={!editPermission} type="date" className="form-control" id="toInput" placeholder="jjjj-m-t" value={to} onChange={e => setTo(e.target.value)}/>
                </div>
                <button disabled={!editPermission} type="button" className="btn btn-primary" onClick={addOpening} >Hinzufügen</button>                            
            </div>                            
    )
}

export default Openings;